module.exports = __webpack_public_path__ + "img/sales-order-status.e5b0b219.svg";